// Single shared ApiClient + per-domain API surfaces. Imported wherever the
// app needs to talk to the Go API.

import {
  ApiClient,
  authApi,
  integrationsApi,
  invitesApi,
  meetingsApi,
  tenantsApi,
} from "@jotty/api-client";

const baseUrl = import.meta.env.VITE_API_BASE_URL;
if (!baseUrl) {
  throw new Error(
    "VITE_API_BASE_URL is not set — copy .env.example to .env in apps/web/",
  );
}

export const apiClient = new ApiClient({ baseUrl });

export const auth = authApi(apiClient);
export const tenants: ReturnType<typeof tenantsApi> = tenantsApi(apiClient);
export const meetings = meetingsApi(apiClient);
export const integrations = integrationsApi(apiClient);
export const invites = invitesApi(apiClient);

export { ApiError } from "@jotty/api-client";
export type {
  User,
  Tenant,
  TenantSettings,
  CreateTenantRequest,
  UpdateTenantRequest,
  CreateInviteRequest,
  Meeting,
  MeetingDetail,
  MeetingStatus,
  MeetingLanguage,
  Summary,
  SummaryContent,
  ActionItem,
  PutSummaryRequest,
  DeliveryChannel,
  DeliveryReceipt,
  Attachment,
  SlackChannelMapping,
} from "@jotty/api-client";
